import * as React from 'react';
import styles from './benefits.module.scss';
import { Icon } from 'components/base/data-display/icon';

type Props = {
    benefits: string[];
};

const Benefits: React.FC<Props> = ({ benefits }: Props) => {
    const list = benefits.map((b, i) => (
        <li key={i} className={styles.Benefits__Item}>
            <Icon name='checkbox_filled' />
            <span className={styles.Item__Text}>{b}</span>
        </li>
    ));

    return (
        <ul data-testid='component-benefits' className={styles.Benefits__List}>
            {list}
        </ul>
    );
};

export default React.memo(Benefits);
